const Config = {
  errObj: {
    show: false,
    msg: ''
  }
}

export default Config



// WEBPACK FOOTER //
// ./src/utils/config.js